module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewPrintModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.print()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printLoan"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [(_vm.seeRecord.member) ? _c('div', {
    staticClass: "card-body box-profile"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('td', {
    attrs: {
      "width": "18%"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "height": "90"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                        "), _c('br'), _vm._v("CIN : " + _vm._s(_vm.getCompanyRecord.cin) + ", Website - " + _vm._s(_vm.getCompanyRecord.url) + ", Mobile No - " + _vm._s(_vm.getCompanyRecord.phone) + ", Email ID - " + _vm._s(_vm.getCompanyRecord.email) + "\n                        ")])])]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    attrs: {
      "width": "20%"
    }
  }, [_c('barcode', {
    attrs: {
      "value": _vm.seeRecord.member.code,
      "height": "45",
      "width": "1"
    }
  }, [_vm._v("\n                          Show this if the rendering fails.\n                        ")])], 1)])]), _vm._v(" "), _c('hr', {
    attrs: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('thead', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('th', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Branch : " + _vm._s(_vm.seeRecord.branch.name) + " (" + _vm._s(_vm.seeRecord.branch.branchCode) + ")")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Date : " + _vm._s(_vm._f("myDate")(_vm.seeRecord.created_at)))])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('tr', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.seeRecord.member.name) + " (" + _vm._s(_vm.seeRecord.member.code) + ")")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Contact No : ")]), _vm._v(_vm._s(_vm.seeRecord.member.mobile))]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("DOB :")]), _vm._v(" " + _vm._s(_vm._f("myDate")(_vm.memberDetail.dob)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v(" Gender : ")]), _vm._v(_vm._s(_vm.memberDetail.gender))]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  })]), _vm._v(" "), (_vm.memberDetail.spouseName) ? _c('tr', [_vm._m(3), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.memberDetail.spouseName))]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  })]) : _c('tr', [_vm._m(4), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.memberDetail.fatherName))]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  })]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('tr', [_vm._m(6), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.memberDetail.address) + ", " + _vm._s(_vm.memberDetail.area))]), _vm._v(" "), _vm._m(7), (_vm.memberDetail.state) ? _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.memberDetail.district) + ", " + _vm._s(_vm.memberDetail.state.name) + " - " + _vm._s(_vm.memberDetail.pin))]) : _vm._e()]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Bank : ")]), _vm._v(" "), (_vm.memberDetail.bank) ? _c('span', [_vm._v(" " + _vm._s(_vm.memberDetail.bank.name))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Branch : ")]), (_vm.memberDetail.bankBranch) ? _c('span', [_vm._v(" " + _vm._s(_vm.memberDetail.bankBranch))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Loan ID :")]), _vm._v(" "), (_vm.seeRecord.member_loan_plan) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.member_loan_plan.applicationNo))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Plan Name :")]), _vm._v(" " + _vm._s(_vm.pl.name))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Account Holder : ")]), _vm._v(_vm._s(_vm.memberDetail.accountHolderName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Account Number : ")]), _vm._v(" "), (_vm.memberDetail.accountNumber) ? _c('span', [_vm._v(_vm._s(_vm.memberDetail.accountNumber))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [(_vm.pl.rateOfInterest > 0) ? _c('strong', [_vm._v("Interest Rate (%) : " + _vm._s(_vm.pl.rateOfInterest) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("GST Include : ")]), _vm._v(_vm._s(_vm.pl.includeGst))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("IFSC : ")]), _vm._v(_vm._s(_vm.memberDetail.ifsc))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Plan Amount :")]), _vm._v(" " + _vm._s(_vm.planAmt(_vm.seeRecord)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("File Charge : ")]), _vm._v(_vm._s(_vm.fileChargeFee(_vm.seeRecord)))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_vm._m(9), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Processing Fee :")]), _vm._v(" " + _vm._s(_vm.processingFee(_vm.seeRecord)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Insurance Fee :")]), _vm._v(" " + _vm._s(_vm.insuranceFee(_vm.seeRecord)))])]), _vm._v(" "), (_vm.pl.rateOfInterest) ? _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Income (INR) : ")]), _vm._v(_vm._s(_vm.memberDetail.incomeAmount))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Occupation : ")]), _vm._v(_vm._s(_vm.memberDetail.jobType))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Recovery type :")]), _vm._v(" " + _vm._s(_vm.pl.recoveryType))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Amount to be Paid :")]), _vm._v(" "), (_vm.seeRecord.loanAmount) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.loanAmount))]) : _c('span', [_vm._v(" " + _vm._s(_vm.pl.amount))])])]) : _vm._e(), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Business Name : ")]), _vm._v(_vm._s(_vm.memberDetail.businessName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Income Type : ")]), _vm._v(_vm._s(_vm.memberDetail.incomeType))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("No of Payments : ")]), _vm._v(" "), (_vm.pl.noOfPayments) ? _c('span', [_vm._v(_vm._s(_vm.pl.noOfPayments))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Minimum Income : ")]), _vm._v(_vm._s(_vm.memberDetail.minAmount))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Purpose : ")]), (_vm.seeRecord.purpose) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.purpose.purpose))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Description : ")]), _vm._v(_vm._s(_vm.seeRecord.description))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._m(10), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "rowspan": "3"
    }
  }, [_c('div', {
    staticStyle: {
      "border-width": "3px",
      "border-style": "solid",
      "width": "110px",
      "height": "120px",
      "float": "right",
      "text-align": "center"
    }
  }, [_c('br'), _c('center', [_vm._v("Guarantor Photo "), _c('br'), _vm._v("with Cross Sign")])], 1)])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._m(11), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.memberDetail.guarantorName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Contact Number : ")]), _vm._v(_vm._s(_vm.memberDetail.guarantorPhone) + " ")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._m(12), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.memberDetail.guarantorAddress))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Narration : ")]), _vm._v(_vm._s(_vm.memberDetail.guarantorNarration))])]), _vm._v(" "), _c('tr', [_vm._m(13), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Nominee Name : ")]), _vm._v(_vm._s(_vm.memberDetail.nomineeName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Contact Number : ")]), _vm._v(_vm._s(_vm.memberDetail.nomineePhone))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Nominee Dob : ")]), _vm._v(_vm._s(_vm.memberDetail.nomineeDob))])])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('p', [_vm._v("1. उपरोक्त सभी पक्ष निम्नलिखित सभी शर्ते व नियम पर अपनी सहमति व्यक्त करते हैं यह है कि ऋण धारी इस राशि का उपयोग माइक्रोफाइनेंस की नियमावली समझकर करेंगे तथा इस राशि या इसके किसी भी अंश का उपयोग अन्य किसी भी उद्देश्य की पूर्ति हेतु नहीं करेंगे जिसके लिए इसे स्वीकृत नहीं किया गया है हम इसके लिए भी सहमति व्यक्त करते हैं कि यदि कंपनी को सबसे कोई कारण मिलता है जो स्पष्ट करता है कि सर्च की पालना नहीं की गई है तो कंपनी को अधिकार है कि वह इस ऋण राशि या उसके अंश को बिना किसी रियायत के वापस ले लेंगे")]), _vm._v(" "), _c('p', [_vm._v("2. मैं /हम लोन के लिए आवेदन करने वाले तथा गारंटर पूर्व में किसी भी गैर कानूनी कार्य में लिप्त नहीं है और ना ही किसी न्यायालय में हमारे विरुद्ध आपराधिक मामला विचाराधीन है और ना ही किसी भी थाने में कोई एफ आई आर दर्ज है।")]), _vm._v(" "), _c('p', [_vm._v("3. यह है कि मैं / हमें किसी वित्तीय संस्थान, बैंक या फाइनेंस कंपनी से मुझे / हमको डिफॉल्टर घोषित नहीं किया गया है।")]), _vm._v(" "), _c('p', [_vm._v("4. यह है कि मैं हम उक्त लोन की संपूर्ण किस्तों का भुगतान करने में पूरी तरह से सक्षम है और किसी भी विपरीत परिस्थिति में मैं हम भुगतान करने में देरी नहीं करेंगे।")]), _vm._v(" "), _c('p', [_vm._v("5. यह है कि कंपनी का जो भी कर्मचारी किस्त की राशि का कलेक्शन करने आएगा मैं उसके साथ विनम्र व्यवहार रखूंगा  रखेंगे एवं उसे किसी भी प्रकार की आपत्तिजनक बात ना कहेंगे किसी भी प्रकार का उसको नुकसान या मारपीट की कोशिश नहीं करेंगे और ना ही उसके खिलाफ गंदे व्यवहार या अपशब्द बोलने आरोप नहीं लगाएंगे अगर हमारे द्वारा कोई भी अभद्र व्यवहार किया जाता है तो कंपनी कर्मचारी तथा कंपनी हमारे प्रति कानूनी कार्रवाई करने के लिए स्वतंत्र होंगे")]), _vm._v(" "), _c('p', [_vm._v("6. यह है कि मैं हम नियत तिथि की सूचना देने से संबंधित जानकारी अपनी किस्तों के संपूर्ण भुगतान के लिए नोटिस रिमाइंडर व इलेक्ट्रॉनिक सूचना फोन इत्यादि करने के लिए कंपनी जिम्मेदार नहीं होगी इस बात की याददाश्त संबंधित संपूर्ण जिम्मेदारी मेरी या  हमारी होगी")]), _vm._v(" "), _c('p', [_vm._v("7. यह है कि अगर ऋणी या गारंटर अपने व्यवसाय नौकरी मूल निवास मोबाइल नंबर या ईमेल आईडी का परिवर्तन करता है तो इस बात की सूचना कंपनी को पूर्व में लिखित प्रदान करेंगे")]), _vm._v(" "), _c('p', [_vm._v("8. यह है कि मैं /हम यह वचनबद्ध बयान करते हैं कि भविष्य में यदि हमारे द्वारा किस्तों का भुगतान चेक के माध्यम से किया जाता है तो हम दिए गए चेकों को बैंक में स्टॉप नहीं कराएंगे और ना ही उक्त चेक के खोने की रिपोर्ट दर्ज थाने में कराएंगे और ना ही उक्त खाते को बंद कर आएंगे यदि हम ऐसा करते हैं तो कंपनी हमारे विरुद्ध कानूनी कार्रवाई करने का अधिकार रखेगी !")]), _vm._v(" "), _c('p', [_vm._v("9. यह है कि कंपनी द्वारा के संग्रहण संबंधित जो सुविधाएं जैसे कि s.m.s. कॉलिंग मेल किया नोटिस प्रदान करने के लिए जो भी सर्विस चार्ज अलग से मांगेंगे वह हम प्रदान करेंगे|")]), _vm._v(" "), _c('p', [_vm._v("10. यह है कि इस अनुबंध के अनुसार गारंटर की पूरी जिम्मेदारी और उत्तरदायित्व  है अगर भविष्य में आवेदक के साथ  कोई आकस्मिक घटना मृत्यु या दिवालिया या गंभीर बीमारी हो जाती है तो संपूर्ण लोन का भुगतान गारंटर द्वारा किया जाएगा")]), _vm._v(" "), _c('p', [_vm._v("11. यह है कि हम मैं द्वारा कंपनी को दी गई संपूर्ण जानकारी मौखिक प्रदान की गई है जो कि सत्य व सही है जिसमें किसी भी प्रकार का कोई भी झूठा तथ्य नहीं बताया गया है यदि कोई जानकारी झूठी पाई जाती है तो कंपनी हमारे विरोध कानूनी कार्रवाई करने का अधिकार रखेगी मैं हम ने लोन के बारे में समस्त जानकारी जैसे ब्याज कथा किस्तों की राशि किस्तों का समय और अदायगी का समय अच्छी तरह से समझ लिया है कंपनी कर्मचारी द्वारा मुझे संपूर्ण जानकारी दे दी गई है उक्त सभी नियमों व शर्तों के लिए मैं हम पूरी तरह तैयार है और अगर मैं हम किस्त देने में देरी करते हैं तो उस पर लगने वाला अतिरिक्त भार लीगल खर्चा पेपर खर्चा विजिट खर्चा व अन्य खर्च जो भी भविष्य में आएगा वह हमारे द्वारा प्रदान किया जाएगा | ")]), _vm._v(" "), _c('p', [_vm._v("12. यह है कि मैं हम प्रस्तुत किए गए समस्त दस्तावेज जैसे कि आधार कार्ड पैन कार्ड राशन कार्ड ड्राइविंग लाइसेंस बैंक की पासबुक व फोटो के साथ किसी भी तरह की छेड़छाड़ या कोई भी फर्जी दस्तावेज हमारे द्वारा प्रस्तुत नहीं किया गया है निकट भविष्य में अगर किसी भी दस्तावेज के फर्जी पाए जाने पर हमारे खिलाफ 420 ई का मुकदमा कंपनी द्वारा किया जा सकता है किस बात से हम पहले से जानकार हैं | ")]), _vm._v(" "), _c('p', [_vm._v("13. यह है कि हम मैं अपनी किस्तों का भुगतान साप्ताहिक रूप में करना चाहता हूं | ")]), _vm._v(" "), _c('p', [_vm._v("14. यह है कि इस ऋण के भुगतान और उसके बकाया या किसी भी अंश की स्वीकृति या किसी भी अन्य विशिष्ट कार्य हेतु जब भी कंपनी द्वारा बुलाया जाएगा मैं हम समय पर उपस्थित हो जाएंगे | ")]), _vm._v(" "), _c('p', [_vm._v("15. यह है कि मेरी सालाना आय ₹500000 से कम है उक्त एग्रीमेंट या लोन को करते समय हमने किसी भी प्रकार का कोई नशा नहीं किया हुआ है हम पूरे होशो हवास में यह एग्रीमेंट कर रहे हैं | ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('p', [_vm._v("1. All the above parties agree on all the following terms and condition that the borrower will use this amount as\n                    per the rules of microfinance and will not use this amount or any part of it for any other purpose. We also agree\n                    that if the company finds any reason to explain which has not been complied with, the company has the right to\n                    withdraw this loan amount or part thereof without any Will withdraw the concession.")]), _vm._v(" "), _c('p', [_vm._v("2. I and my guarantor are not involved in any illegal act in the past and neither a criminal case is pending against\n                    us in any court nor any FIR is registered in any police station.")]), _vm._v(" "), _c('p', [_vm._v("3. That I/We are not burdened with any kind of loan from any financial institution, bank finance company, nor\n                    have I/we been declared a defaulter from any financial institution, bank or finance company.")]), _vm._v(" "), _c('p', [_vm._v("4. That I/we are fully capable of paying the entire instalments of the said loan and I/We shall not delay the\n                    payment under any circumstances")]), _vm._v(" "), _c('p', [_vm._v("5. That whichever employee of the company will come to collect the instalment amount, I will keep polite\n                    behaviour with them and will not call him any kind of objectionable thing, will not try to harm or beat him in any\n                    way nor will he be dirty against him. Will not allege behaviour or abusive language If any abusive behaviour is\n                    done by us then company will be free to take legal action against us.")]), _vm._v(" "), _c('p', [_vm._v("6. That I/We the company will not be responsible for giving notices, reminders and electronic information\n                    phone etc. For the full payment of my instalments related to intimation of the due date of payment of the loan,\n                    the entire responsibility related to this will be my / ours.")]), _vm._v(" "), _c('p', [_vm._v("7. That if the Borrower (s) or the Guarantor (s) change their business, job, Domicile , Mobile number or email\n                    Id, they shall give prior written notice to the company.")]), _vm._v(" "), _c('p', [_vm._v("8. That I / We undertake to make a statement that if the instalments are paid by us in future through are paid by\n                    us in future through cheque, then we will not make stop payment of the checks given in the bank nor report the\n                    loss of the said check to the police station. Nor will we close that account, if we do so, the company will have the\n                    right to take legal action against us.")]), _vm._v(" "), _c('p', [_vm._v("9. This is during the Company’s storage related facilities Such as S.M.S. we will provide the additional service\n                    charge required for providing the calling, email notice.")]), _vm._v(" "), _c('p', [_vm._v("10. That the guarantor is fully responsible and liable as per this agreement, if any accidental event ,death or\n                    insolvency or serious illness occurs with the application future, the entire loan shall be paid by the guarantor.")]), _vm._v(" "), _c('p', [_vm._v("11. That all the information given by me/us to the company has been provided orally which is the true and\n                    correct in which no false fact of any kind have been told , if any information is found to be false then the\n                    company has the right to take legal action against us. I will keep all the information about the loan, Such as the\n                    amount of interest. Instalment, the time of instalment and the time of repayment. I have been given complete\n                    information by the company employee, we are fully prepared for all the above terms and condition and if\n                    me/we delay in paying the instalment, then the additional burden of legal expanses and other expenses which\n                    will come in future will be provided by us.")]), _vm._v(" "), _c('p', [_vm._v("12. That all the documents submitted by me/us Such as Aadhar card, Pan card , Ration card, Driving license,\n                    Bank Passbook and Photo have not been tampered with or any fake document has been submitted by us near in\n                    future, if any document is found to be forged, we can be sued for 420 by the company, which we are already\n                    aware of.")]), _vm._v(" "), _c('p', [_vm._v("13. That me/we want to pay our instalments monthly.")]), _vm._v(" "), _c('p', [_vm._v("14. That I/we shall be present in time as and when called for by the company for the payment of this loan and\n                    acceptance of the arrears or any part thereof or for any other specified purpose. ")]), _vm._v(" "), _c('p', [_vm._v("15. That my annual income is less than 500000/-, we have not done any kind of intoxication while doing the said\n                    agreement or loan, we are doing this agreement in full consciousness.")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), (_vm.seeRecord.status == 'pending') ? _c('div', [_c('br'), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("Application Date")]), _vm._v(" "), _c('th', [_vm._v("Customer")]), _vm._v(" "), _c('th', [_vm._v("Account Number")]), _vm._v(" "), _c('th', [_vm._v("Guarantor Name")]), _vm._v(" "), _c('th', [_vm._v("Plan Amount")]), _vm._v(" "), _c('th', [_vm._v("Amount to be Paid")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pl.planType === 'normal'),
      expression: "pl.planType === 'normal'"
    }]
  }, [_vm._v("No. of EMI")])]), _vm._v(" "), _c('tbody', [_c('td', [_vm._v(_vm._s(_vm._f("myDate")(_vm.seeRecord.disbursementDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecord.member.name) + " (" + _vm._s(_vm.seeRecord.member.code) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.memberDetail.accountNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.memberDetail.guarantorName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.planAmt(_vm.seeRecord)))]), _vm._v(" "), _c('td', [(_vm.seeRecord.loanAmount) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.loanAmount))]) : _c('span', [_vm._v(" " + _vm._s(_vm.pl.amount))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pl.planType === 'normal'),
      expression: "pl.planType === 'normal'"
    }]
  }, [_vm._v(_vm._s(_vm.pl.noOfPayments))])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.seeRecord.status == 'pending') ? _c('table', {
    staticClass: "table"
  }, [_vm._m(16)]) : _vm._e(), _vm._v(" "), _c('br'), _c('br')]) : _vm._e()]) : _vm._e()])])])]), _vm._v(" "), _vm._m(17)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "width": "20%"
    }
  }, [_c('strong', [_vm._v("Customer Name ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px",
      "text-align": "right"
    },
    attrs: {
      "rowspan": "3"
    }
  }, [_c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "border-width": "3px",
      "border-style": "solid",
      "width": "110px",
      "height": "120px",
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("Customer Photo "), _c('br'), _vm._v("with Cross Sign")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Spouse Name  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("C/O ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Address Details")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Address ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("District/State/Pincode ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Bank Details")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Applied Loan Details")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Income Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Guarantor Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Name ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Address ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Nominee Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("(सदस्या के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(जमानतदार के हस्ताक्षर)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("(सदस्या के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(जमानतदार के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Branch Seal With Signature "), _c('br'), _vm._v("(शाखा मोहर के साथ हस्ताक्षर)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Branch Manager Signature")]), _vm._v(" "), _c('th', [_vm._v("Customer Signature")]), _vm._v(" "), _c('th', [_vm._v("Date")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            CLOSE\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-96691a56!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/Loan/ViewLoan.vue
// module id = 807
// module chunks = 0